module.exports = __webpack_public_path__ + "img/whsqyfw.cc736d0b.png";